import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { v4 as uuidv4 } from 'uuid';
export const TransferHistorySkeleton = () => {
    const skeletonRows = Array.from({ length: 5 });
    return (
        <SkeletonTheme baseColor="#a8e6cf" highlightColor="#b9fbc0">
                {skeletonRows.map(() => (
                    <tr key={uuidv4()}> {/* Generating a unique key */}
                        <td>
                            <div className='TransCnTd'>
                                <Skeleton height={25} />
                            </div>
                        </td>
                        <td>
                            <div className='TransCnTd'>
                                <Skeleton height={25} />
                            </div>
                        </td>
                        <td>
                            <div className='TransCnTd'>
                                <Skeleton height={25} />
                            </div>
                        </td>
                        <td><Skeleton height={25} /></td>
                        <td><Skeleton height={25} /></td>
                        <td><Skeleton height={25} /></td>
                        <td><Skeleton height={25} /></td>
                        <td><Skeleton height={25} /></td>
                        <td><Skeleton height={25} /></td>
                        <td><Skeleton height={25} /></td>
                        <td><Skeleton height={25} /></td>
                        <td><Skeleton height={25} /></td>

                    </tr>
                ))}
        </SkeletonTheme>
    );
};